import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FaTachometerAlt,
  FaUser,
  FaBuilding,
  FaCoins,

  FaUserTie,
  FaList,
  FaUserSecret,
  FaRegFileAlt,
  FaPauseCircle,
  FaUserClock,
  FaFileContract,
  FaStamp,
  FaFolderOpen,

} from "react-icons/fa";
import { FiUsers } from "react-icons/fi";

import {
  MdLogout,
  MdMenu,
  MdClose,
  MdKeyboardArrowDown,
  MdOutlineHeadsetMic,
  MdOutlineReceiptLong,
} from "react-icons/md";

import { HiOutlineMapPin } from "react-icons/hi2";

import {
  FaFilePen,
  FaFolderClosed, FaPersonWalking,
  FaUserCheck,
  FaUsers
} from "react-icons/fa6";
import { FaHandshake } from "react-icons/fa";
import { IoAlarmOutline } from "react-icons/io5";
import Images from "../Images";
import tw from "tailwind-styled-components";
import { capitalizeFirstLetter, getRole, getUserType } from "../helpers";
import Config from "../Config";
import SideModal from "./SideModal";
import ProfileModal from "./ProfileModal";

const SideNabar = ({ onLogoutClick }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [openSections, setOpenSections] = useState({
    property: false,
    // money: false,
    // tenants: false,
    // quickAction: false,
    // landlords: false,
  });
  const user = useSelector((state) => state.UserReducer.user);
  // const isStampRequired = useSelector((state) => state.IsStampRequiredReducer.isStampRequired);

  // const selectProperty = useSelector(
  //   (state) => state.SelectPropertyReducer.selectProperty
  // );
  const storedPartner = useSelector((state) => state.SelectedPartnerReducer.selectPartner);
  // const propId = selectProperty.id;
  // const hasPermission = (userPermissions, bitIndex) =>
  // (userPermissions & (1 << bitIndex)) !== 0;

  useEffect(() => {
    setIsMobileOpen(false);
  }, [pathname]);

  const resetTablePagination = () => {
    // Add all your table keys here
    sessionStorage.removeItem("tenant_active_page");
    sessionStorage.removeItem("tenant_expiring_page");
    sessionStorage.removeItem("tenant_movedout_page");
    sessionStorage.removeItem("landlord_list_page");
    sessionStorage.removeItem("dues_page");
    sessionStorage.removeItem("collections_page");
    sessionStorage.removeItem("expenses_page");
    sessionStorage.removeItem("property_list_page");
    // …add all other table keys used in your pages
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileOpen && !event.target.closest('.sidebar-container') && !event.target.closest('.mobile-menu-button')) {
        setIsMobileOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileOpen]);

  useEffect(() => {
    if (isMobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileOpen]);

  // const handleInventoryNavigation = (e) => {
  //   if (propId === 0) {
  //     navigate("/inventory-list");
  //   } else {
  //     navigate("/inventory");
  //   }
  //   e.preventDefault();
  // };

  useEffect(() => {
    const newOpenSections = {
      property: false,
      // money: false,
      // tenants: false,
      // quickAction: false,
      // landlords: false,
    };

    if (pathname === '/inventory/operational' || pathname === '/inventory/details' || pathname === '/properties/agreements' || pathname === '/inventory/unavailable' || pathname === '/properties/lockin-tracker' || pathname === '/inventory' || pathname === '/properties/recurring-exp' || pathname === '/property-extra-charges' || pathname === '/electricity-bill' || pathname === '/landlord/property-list' || pathname === '/landlord/agreement') {
      newOpenSections.property = true;
    }
    if (pathname === '/deals/pipeline' || pathname === '/deals/closed') {
      newOpenSections.deals = true;
    }
    if (
      pathname === '/tenants/agreement' ||
      pathname === '/owners/agreements'
    ) {
      newOpenSections.agreement = true;
    }
    if (
      pathname === '/tenants/active' || pathname === '/tenants/moved-out'
    ) {
      newOpenSections.tenants = true;
    }
    // else if (pathname === '/tenants/active' || pathname === '/tenants/expiring-agreements' || pathname === '/tenants/moved-out' || pathname === '/tenants/agreement' || pathname.includes("tenantdetails/l")) {
    //       newOpenSections.tenants = true;
    //     } else if (pathname === '/leads' || pathname === '/staffs' || pathname === '/notice' || pathname === '/extracharges' || pathname === '/vendors' || pathname === '/activity-logs' || pathname.includes("vendors-expense")) {
    //       newOpenSections.quickAction = true;
    //     } else if (pathname === '/landlords' || pathname === '/landlords/payments' || pathname === '/landlord/transactions' || pathname === '/landlord/pending-dues' || pathname === '/landlord/details') {
    //       newOpenSections.landlords = true;
    //     } else if (pathname === '/property-list' || pathname === '/property-detail' || pathname === '/properties/agreements' || pathname === '/properties/expiring-agreements' || pathname === '/properties/lockin-tracker' || pathname === '/inventory' || pathname === '/properties/recurring-exp' || pathname === '/property-extra-charges' || pathname === '/electricity-bill' || pathname === '/landlord/property-list' || pathname === '/landlord/agreement') {
    //       newOpenSections.property = true;
    //     }

    setOpenSections(newOpenSections);
  }, [pathname]);

  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const isOwner =
    user?.userType === Config.USER_TYPE.CLIENT ||
    user?.role === Config.STAFF_ROLES.PARTNER;
  const isAdmin =
    user?.role === Config.STAFF_ROLES.ADMIN &&
    user?.userType === Config.USER_TYPE.STAFF;
  const isFinance =
    user?.role === Config.STAFF_ROLES.FINANCEADMIN &&
    user?.userType === Config.USER_TYPE.STAFF;
  const isLandlord = user?.userType === 5;

  const landlordMenuItems = [
    // {
    //   type: "link",
    //   href: "/landlord/dashboard",
    //   icon: FaTachometerAlt,
    //   label: "Dashboard",
    //   active: pathname === "/landlord/dashboard"
    // },
    // {
    //   type: "dropdown",
    //   key: "property",
    //   icon: FaBuilding,
    //   label: "Properties",
    //   isOpen: openSections.property,
    //   onToggle: () => toggleSection("property"),
    //   items: [
    //     {
    //       href: "/landlord/property-list",
    //       icon: FaList,
    //       label: "List",
    //       active: pathname === "/landlord/property-list"
    //     },

    //     {
    //       href: "/landlord/agreement",
    //       icon: FaFileContract,
    //       label: "Agreement",
    //       active: pathname === "/landlord/agreement"
    //     },
    //   ]
    // },
    // {
    //   type: "link",
    //   href: "/landlord/client",
    //   icon: FaUser,
    //   label: "Primary Tenants",
    //   active: pathname === "/landlord/client"
    // },
    // {
    //   type: "link",
    //   href: "/landlord/dues",
    //   icon: TbCalendarDue,
    //   label: "Dues",
    //   active: pathname === "/landlord/dues"
    // },
    // {
    //   type: "link",
    //   href: "/landlord/collections",
    //   icon: FaCoins,
    //   label: "Collection",
    //   active: pathname === "/landlord/collections"
    // },
  ]

  const regularMenuItems = [
    // Dashboard
    //(isOwner || isAdmin || isFinance) &&
     {
      type: "link",
      href: "/dashboard",
      icon: FaTachometerAlt,
      label: "Dashboard",
      active: pathname === "/dashboard"
    },
    {
      type: "dropdown",
      key: "inventory",
      icon: FaBuilding,
      label: "Inventory",
      isOpen: openSections.property,
      onToggle: () => toggleSection("property"),
      items: [
        {
          href: "/inventory/operational",
          icon: FaList,
          label: "Operational",
          active: pathname === "/inventory/operational"
        },
        {
          href: "/inventory/unavailable",
          icon: FaPauseCircle,
          label: "Unavailable",
          active: pathname === "/properties/unavailable"
        },
        // {
        //   href: "/properties/recurring-exp",
        //   icon: SiPivotaltracker,
        //   label: "Recurring Payables",
        //   active: pathname === "/properties/recurring-exp"
        // },
      ]
    },
    // Inventory
    // {
    //   type: "link",
    //   href: "/inventory/operational",
    //   icon: FaBuilding,
    //   label: "Inventory",
    //   active: pathname === "/inventory/operational",
    // },

    {
      type: "dropdown",
      key: "deals",
      icon: FaHandshake,
      label: "Deals",
      isOpen: openSections.deals,
      onToggle: () => toggleSection("deals"),
      items: [
        {
          href: "/deals/pipeline",
          icon: FaList,
          label: "Pipeline",
          active: pathname === "/deals/pipeline"
        },
        {
          href: "/deals/closed",
          icon: FaFolderClosed,
          label: "Closed", //Lost and Cancelled
          active: pathname === "/deals/closed"
        },
      ]
    },

    {
      type: "dropdown",
      key: "agreement",
      icon: FaUserClock,
      label: "Agreement",
      isOpen: openSections.agreement,
      onToggle: () => toggleSection("agreement"),
      items: [
        {
          href: "/tenants/agreement",
          icon: IoAlarmOutline,
          label: "Tenants Agreement",
          active: pathname === "/tenants/agreement"
        },
        {
          href: "/owners/agreements",
          icon: FaFileContract,
          label: "Owners Agreement",
          active: pathname === "/owners/agreements"
        },
      ]
    },
    // {
    //   type: "link",
    //   href: "/complaints",
    //   icon: MdOutlineHeadsetMic,
    //   label: "Complaints",
    //   active: pathname === "/complaints"
    // },

    // Deals
    // {
    //   type: "link",
    //   href: "/deals/pipeline",
    //   icon: FaHandshake,
    //   label: "Deals",
    //   active: pathname === "/deals/pipeline",
    // },

    // {
    //   type: "dropdown",
    //   key: "tenants",
    //   icon: FaUsers,
    //   label: "Tenants",
    //   isOpen: openSections.tenants,
    //   onToggle: () => toggleSection("tenants"),
    //   items: [
    //     {
    //       href: "/tenants/active",
    //       icon: FaUserCheck,
    //       label: "Active",
    //       active: pathname === "/tenants/active"
    //     },
    //     {
    //       href: "/tenants/moved-out",
    //       icon: FaPersonWalking,
    //       label: "Moved Out",
    //       active: pathname === "/tenants/moved-out"
    //     },
    //   ]
    // },

    // Owners
    {
      type: "link",
      href: "/enquiries",
      icon: FiUsers,
      label: "Enquiries",
      active: pathname === "/enquiries",
    },

    // Owners
    {
      type: "link",
      href: "/owners",
      icon: FaUserSecret,
      label: "Owners",
      active: pathname === "/owners",
    },

    // Staffs
   (isOwner)&& {
      type: "link",
      href: "/staffs",
      icon: FaUserTie,
      label: "Staffs",
      active: pathname === "/staffs",
    },

    // Brokers
    {
      type: "link",
      href: "/brokers",
      icon: FaUserTie,
      label: "Brokers",
      active: pathname === "/brokers",
    },
    // Revenue
    (isOwner)&&{
      type: "link",
      href: "/revenue",
      icon: FaCoins,
      label: "Revenue",
      active: pathname === "/revenue",
    },

    // Stamp Paper
    // isStampRequired === Config.STAMP_REQUIRED.YES && { //Some thing for else
    //   type: "link",
    //   href: "/stamp-paper",
    //   icon: FaStamp,
    //   label: "Stamp Papers",
    //   active: pathname === "/stamp-paper",
    // },

    // {
    //   type: "link",
    //   href: "/stamp-paper",
    //   icon: FaStamp,
    //   label: "Stamp Papers",
    //   active: pathname === "/stamp-paper",
    // },

    //Pre Agreement(LOI)
    {
      type: "link",
      href: "/pre-agreement",
      icon: FaFilePen,
      label: "LOI",
      active: pathname === "/pre-agreement"
    },

    //Receipt
    {
      type: "link",
      href: "/invoice",
      icon: MdOutlineReceiptLong,
      // label: "Receipts",
      label: "Invoices",
      active: pathname === "/invoice"
    },

    // Locations
    {
      type: "link",
      href: "/locations",
      icon: HiOutlineMapPin,
      label: "Locations",
      active: pathname === "/locations",
    },

    //Documents
     {
      type: "link",
      href: "/documents",
      icon: FaFolderOpen,
      label: "Documents",
      active: pathname === "/documents",
    },

    // Reports
    {
      type: "link",
      href: "/reports",
      icon: FaRegFileAlt,
      label: "Reports",
      active: pathname === "/reports",
    },

    // Properties with only List submenu
    //     hasPermission("MANANGE_EXPENSES", user) ||
    //       hasPermission("MANANGE_EXTRACHARGES", user) ||
    //       hasPermission("MANANGE_INVENTORY", user)
    //       ?
    // {
    //   type: "dropdown",
    //   key: "property",
    //   icon: FaBuilding,
    //   label: "Properties",
    //   isOpen: openSections.property,
    //   onToggle: () => toggleSection("property"),
    //   items: [
    //     {
    //       href: "/property-list",
    //       icon: FaList,
    //       label: "List",
    //       active: pathname === "/property-list"
    //     },
    // All other property submenus commented out
    // {
    //   href: "/properties/agreements",
    //   icon: FaFileContract,
    //   label: "Agreements",
    //   active: pathname === "/properties/agreements"
    // },
    // {
    //   href: "/properties/recurring-exp",
    //   icon: SiPivotaltracker,
    //   label: "Recurring Payables",
    //   active: pathname === "/properties/recurring-exp"
    // },
    //   ]
    // },

    // All other menu items commented out
    // hasPermission("MANANGE_TENANTS", user) && {
    //   type: "dropdown",
    //   key: "tenants",
    //   icon: FaUsers,
    //   label: "Tenants",
    //   isOpen: openSections.tenants,
    //   onToggle: () => toggleSection("tenants"),
    //   items: [
    //     {
    //       href: "/tenants/active",
    //       icon: FaUserCheck,
    //       label: "Active",
    //       active: pathname === "/tenants/active"
    //     },
    //     {
    //       href: "/tenants/agreement",
    //       icon: IoAlarmOutline,
    //       label: "Expiring Agreement",
    //       active: pathname === "/tenants/agreement"
    //     },
    //     {
    //       href: "/tenants/moved-out",
    //       icon: FaPersonWalking,
    //       label: "Moved Out",
    //       active: pathname === "/tenants/moved-out"
    //     },
    //   ]
    // },

    // hasPermission("MANANGE_DUES", user) ||
    //   hasPermission("MANANGE_COLLECTIONS", user) ||
    //   hasPermission("MANANGE_EXPENSES", user)
    //   ?
    //   {
    //     type: "dropdown",
    //     key: "money",
    //     icon: FaMoneyCheckDollar,
    //     label: "Finance",
    //     isOpen: openSections.money,
    //     onToggle: () => toggleSection("money"),
    //     items: [
    //       hasPermission("MANANGE_DUES", user) && {
    //         href: "/finance/dues",
    //         icon: TbCalendarDue,
    //         label: "Dues",
    //         active: pathname === "/finance/dues"
    //       },
    //       hasPermission("MANANGE_COLLECTIONS", user) && {
    //         href: "/finance/collections",
    //         icon: FaCoins,
    //         label: "Collection",
    //         active: pathname === "/finance/collections"
    //       },
    //       hasPermission("MANANGE_EXPENSES", user) && {
    //         href: "/finance/expenses",
    //         icon: FaMoneyBillWave,
    //         label: "Expenses",
    //         active: pathname === "/finance/expenses"
    //       },
    //     ]
    //   } : null,

    // hasPermission("MANANGE_LANDLORD", user) && {
    //   type: "dropdown",
    //   key: "landlords",
    //   icon: FaUserSecret,
    //   label: "Landlords",
    //   isOpen: openSections.landlords,
    //   onToggle: () => toggleSection("landlords"),
    //   items: [
    //     {
    //       href: "/landlords",
    //       icon: FaList,
    //       label: "List",
    //       active: pathname === "/landlords"
    //     },
    //     {
    //       href: "/landlords/payments",
    //       icon: FaCoins,
    //       label: "Payments",
    //       active: pathname === "/landlords/payments"
    //     },
    //     {
    //       href: "/landlord/pending-dues",
    //       icon: FaClock,
    //       label: "Pending Dues",
    //       active: pathname === "/landlord/pending-dues"
    //     }
    //   ]
    // },

    // hasPermission("MANANGE_REQUESTS", user) && {
    //   type: "link",
    //   href: "/requests",
    //   icon: MdMarkEmailRead,
    //   label: "Request",
    //   active: pathname === "/requests"
    // },

    // hasPermission("MANANGE_COMPLAINTS", user) && {
    //   type: "link",
    //   href: "/complaints",
    //   icon: MdOutlineHeadsetMic,
    //   label: "Complaints",
    //   active: pathname === "/complaints"
    // },

    // (user.parentId === null && storedPartner?.clientId === user.id) && {
    //   type: "link",
    //   href: "/partners",
    //   icon: FaHandshake,
    //   label: "Partners",
    //   active: pathname === "/partners"
    // },

    // {
    //   type: "dropdown",
    //   key: "quickAction",
    //   icon: RiFlashlightFill,
    //   label: "Quick Action",
    //   isOpen: openSections.quickAction,
    //   onToggle: () => toggleSection("quickAction"),
    //   items: [
    //     hasPermission("MANANGE_LEADS", user) && {
    //       href: "/leads",
    //       icon: FaUser,
    //       label: "Leads",
    //       active: pathname === "/leads"
    //     },
    //     hasPermission("MANANGE_STAFF", user) && {
    //       href: "/staffs",
    //       icon: FaUserTie,
    //       label: "Staffs",
    //       active: pathname === "/staffs"
    //     },
    //     hasPermission("MANANGE_STAFF", user) && {
    //       href: "/vendors",
    //       icon: FaUser,
    //       label: "Vendors",
    //       active: pathname === "/vendors"
    //     },
    //     hasPermission("MANANGE_TENANTS", user) && {
    //       href: "/activity-logs",
    //       icon: RxActivityLog,
    //       label: "Activity Logs",
    //       active: pathname === "/activity-logs"
    //     },
    //     hasPermission("MANANGE_EXTRACHARGES", user) && {
    //       href: "/extracharges",
    //       icon: FaMoneyBillTrendUp,
    //       label: "Extra Charges",
    //       active: pathname === "/extracharges"
    //     },
    //   ]
    // },

    // hasPermission("MANANGE_PROPERTY_ASSETS", user) && {
    //   type: "link",
    //   href: "/assets",
    //   icon: BsBuildingGear,
    //   label: "Asset Management",
    //   active: pathname === "/assets"
    // },

    // (isOwner || isAdmin) && {
    //   type: "link",
    //   href: "/settings",
    //   icon: MdSettings,
    //   label: "Settings",
    //   active: pathname === "/settings"
    // },

  ];

  const menuItems = isLandlord ? landlordMenuItems : regularMenuItems;

  const cleanMenu = (menus) => {
    return menus
      .filter(Boolean) // remove false, null, undefined
      .map((item) => {
        if (item.type === "dropdown" && Array.isArray(item.items)) {
          return {
            ...item,
            items: cleanMenu(item.items), // recursively clean submenus
          };
        }
        return item;
      });
  };

  const safeMenuItems = cleanMenu(menuItems);

  const MenuButton = ({ children, isActive, onClick, asLink = false, href = "#", className = "" }) => {
    if (asLink) {
      return (
        <MenuLink
          to={href}
          $isActive={isActive}
          className={className}
        // onClick={() => {
        //   resetTablePagination();   // RESET page indexes on navigation
        // }}
        >
          {children}
        </MenuLink>
      );
    }

    return (
      <MenuButtonWrapper
        onClick={onClick}
        $isActive={isActive}
        className={className}
      >
        {children}
      </MenuButtonWrapper>
    );
  };

  const renderMenuItem = (item) => {
    if (item.type === "link") {
      return (
        <li key={item.href}>
          <MenuButton
            asLink
            href={item.href}
            isActive={item.active}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            <MenuItemLabel
              $isCollapsed={isCollapsed}
              $isMobileOpen={isMobileOpen}
            >
              {item.label}
            </MenuItemLabel>
          </MenuButton>
        </li>
      );
    }

    if (item.type === "dropdown") {
      return (
        <li key={item.key} className="mb-1">
          <MenuButton
            onClick={item.onToggle}
            isActive={item.active}
            className="justify-between"
          >
            <div className="flex items-center gap-3">
              <item.icon className="h-4 w-4 flex-shrink-0" />
              <MenuItemLabel
                $isCollapsed={isCollapsed}
                $isMobileOpen={isMobileOpen}
              >
                {item.label}
              </MenuItemLabel>
            </div>
            <DropdownIcon
              $isOpen={item.isOpen}
              $isCollapsed={isCollapsed}
              $isMobileOpen={isMobileOpen}
            />
          </MenuButton>
          {item.isOpen && (
            <DropdownMenu
              $isCollapsed={isCollapsed}
              $isMobileOpen={isMobileOpen}
            >
              {item.items.map((subItem) => (
                <li key={subItem.href}>
                  <MenuButton
                    asLink
                    href={subItem.href}
                    isActive={subItem.active}
                    className="pl-3"
                  >
                    <subItem.icon className="h-4 w-4 flex-shrink-0" />
                    <span>{subItem.label}</span>
                  </MenuButton>
                </li>
              ))}
            </DropdownMenu>
          )}
        </li>
      );
    }
  };

  const userRole = getRole(user?.userRole);
  const userType = getUserType(user?.userType);

  const SidebarFooter = () => {
    return (
      <FooterContainer>
        {/* User Info Section */}
        <div className="flex justify-between p-1.5 rounded-lg bg-gray-50">

          <UserInfoContainer>
            <UserAvatar>
              <FaUser className="h-4 w-4" />
            </UserAvatar>
            {(!isCollapsed || isMobileOpen) && (
              <UserDetails>
                {/* <UserName>{user?.name ? capitalizeFirstLetter(user?.name) : "User"}</UserName> */}
                <UserName
                  className="cursor-pointer"
                  onClick={() => setIsProfileOpen(true)}
                >
                  {user?.name ? capitalizeFirstLetter(user?.name) : "User"}
                </UserName>
                {user.userRoler ?
                  <UserRole>{userRole}</UserRole> :
                  <UserRole>{userType}</UserRole>}
              </UserDetails>
            )}
          </UserInfoContainer>

          {/* Logout Button */}
          <button className="flex justify-end items-center w-1/4" onClick={onLogoutClick}>
            <MdLogout className="h-4 w-4 flex-shrink-0 text-rose-500" title="Logout" />
          </button>
        </div>
      </FooterContainer>
    );
  };

  return (
    <>
      <MobileMenuButton
        className="mobile-menu-button"
        onClick={toggleMobileSidebar}
      >
        {isMobileOpen ? <MdClose className="h-5 w-5" /> : <MdMenu className="h-5 w-5" />}
      </MobileMenuButton>

      {isMobileOpen && (
        <MobileOverlay onClick={() => setIsMobileOpen(false)} />
      )}

      <SidebarContainer
        $isCollapsed={isCollapsed}
        $isMobileOpen={isMobileOpen}
      >
        <SidebarHeader>
          <div className="flex items-center">
            {(!isCollapsed || isMobileOpen) && (
              <div className="flex items-center gap-3">
                <Logo src={Images.Logo} alt="Logo" />

                <div className="hidden md:flex items-center gap-3">
                  <div className="h-4 w-px bg-gray-300" />
                  <span className="text-sm font-medium text-gray-700">
                    Brokers
                  </span>
                </div>
              </div>
            )}
          </div>

          <MobileCloseButton
            onClick={() => setIsMobileOpen(false)}
          >
            <MdClose className="h-4 w-4" />
          </MobileCloseButton>
        </SidebarHeader>

        <SidebarContent>
          <SidebarNav>
            <SidebarMenu>
              {safeMenuItems.map(renderMenuItem)}
            </SidebarMenu>
          </SidebarNav>
        </SidebarContent>
        <SidebarFooter />

      </SidebarContainer>

      <SideModal
        isOpen={isProfileOpen}
        onClose={() => setIsProfileOpen(false)}
      >
        <ProfileModal
          handleClose={() => setIsProfileOpen(false)}
        />
      </SideModal>
    </>
  );
};

// Styled Components
const MobileMenuButton = tw.button`lg:hidden fixed top-3 left-4 z-10 p-2 bg-white rounded-lg shadow-lg border border-gray-200 text-gray-600 hover:bg-gray-100`;
const MobileOverlay = tw.div`lg:hidden fixed inset-0 bg-black bg-opacity-50 z-5 transition-opacity duration-300`;
const SidebarContainer = tw.div`no-scrollbar sidebar-container flex flex-col bg-white transition-all duration-300 h-screen z-10 ${props => props.$isCollapsed ? 'w-16' : 'w-60'} lg:static lg:translate-x-0 lg:shadow-none fixed top-0 left-0 ${props => props.$isMobileOpen ? 'translate-x-0 shadow-2xl' : '-translate-x-full'} ${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:w-16' : ''}`;
const SidebarHeader = tw.div`sidebar-header flex items-center justify-between p-4 min-h-16`;
const Logo = tw.img`w-[94px] h-[5=35px]`;
const MobileCloseButton = tw.button`lg:hidden flex items-center justify-center w-8 h-8 rounded-md border border-gray-200 bg-transparent text-gray-600 cursor-pointer transition-all duration-200 hover:bg-gray-100 hover:text-gray-900`;
const SidebarContent = tw.div`sidebar-content flex-1 overflow-y-auto p-2 no-scrollbar`;
const SidebarNav = tw.nav`sidebar-nav h-full`;
const SidebarMenu = tw.ul`sidebar-menu list-none p-0 m-0`;
const MenuButtonWrapper = tw.button`flex items-center gap-3 w-full p-3 text-base rounded-md transition-all duration-200 hover:text-primary-color ${props => props.$isActive ? 'text-primary-color' : 'text-gray-600'} ${props => props.className || ''}`;
const MenuLink = tw(Link)`flex items-center gap-3 w-full p-3 text-base rounded-md transition-all duration-200 hover:text-primary-color ${props => props.$isActive ? 'text-primary-color' : 'text-gray-600'} ${props => props.className || ''}`;
const DropdownIcon = tw(MdKeyboardArrowDown)`h-4 w-4 transition-transform ${props => props.$isOpen ? "rotate-180" : ""} ${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:hidden' : ''} ${props => props.$isMobileOpen ? 'block' : 'lg:block'}`;
const DropdownMenu = tw.ul`ml-4 mt-1 space-y-1 border-l-2 border-gray-200 pl-3 ${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:hidden' : ''} ${props => props.$isMobileOpen ? 'block' : 'lg:block'}`;
const MenuItemLabel = tw.span`${props => props.$isCollapsed && !props.$isMobileOpen ? 'lg:hidden' : ''} ${props => props.$isMobileOpen ? 'block' : 'lg:block'}`;

const FooterContainer = tw.div`p-4 border-t border-gray-200`;
const UserInfoContainer = tw.div`flex items-center gap-3 w-3/4`;
const UserAvatar = tw.div`flex items-center justify-center w-8 h-8 rounded-full bg-primary-color text-white flex-shrink-0`;
const UserDetails = tw.div`flex flex-col min-w-0`;
const UserName = tw.span`text-sm font-medium text-gray-900 truncate`;
const UserRole = tw.span`text-xs text-gray-500 truncate`;

export default SideNabar;











































































// import React, { useState, useEffect } from "react";
// import { Formik, Field, Form } from "formik";
// import {
//   InputGroup,
//   FieldWrappers,
//   Label,
//   SubmitBtn,
//   SideCancelBtn,
//   Wrapper,
//   ScrollableContent,
//   ActionSection,
//   MobileIcon,
//   ModalHeader,
//   CombineInputGroup,
//   ModalSubHeading,
//   ModalHeading,
// } from "./Styles/InputStyles";
// import { MdClose } from "react-icons/md";
// import tw from "tailwind-styled-components";
// import * as Yup from "yup";
// import "react-datepicker/dist/react-datepicker.css";
// import DropZone from "./Notice/Dropzone";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import Config from "../Config";
// import { toast } from "react-toastify";
// import { useMutation } from "react-query";
// import Loading from "../Components/Loading";


// // Step 1 Validation Schema
// const stepOneSchema = Yup.object().shape({
//   companyName: Yup.string()
//     .matches(
//       /^[A-Za-z0-9. - ]+$/,
//       "Only alphabets, numbers, spaces and hyphens are allowed"
//     )
//     .min(3, "Company name must be at least 3 characters long")
//     .required("Company name is required"),

//   gstNo: Yup.string().nullable(),
//   panNo: Yup.string().nullable(),
//   businessAddress: Yup.string().nullable(),
// });

// const stepTwoSchema = Yup.object().shape({
// //   logo: Yup.mixed().required("Logo is required"),
//   bankName: Yup.string().nullable(),
//   accountNo: Yup.string().nullable(),
//   ifscCode: Yup.string().nullable(),
// });

// const ProfileModal = ({
//    handleClose 
// }) => {
//   const user = useSelector((state) => state.UserReducer.user);
//   const [currentStep, setCurrentStep] = useState(1);
//   const [formData, setFormData] = useState({
//     companyName: "",
//     gstNo: "",
//     businessAddress: "",
//     panNo: "",
//     bankName: "",
//     accountNo: "",
//     ifscCode: "",
//     logo: null,
//     signature: null,
//   });

//   const [height, setHeight] = useState(window.innerHeight);

//   useEffect(() => {
//     const handleResize = () => {
//       setHeight(window.innerHeight);
//     };

//     window.addEventListener("resize", handleResize);
//     handleResize();

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   //--Fetch the Company Details-----------------------------------------------
//   const getProfileFunction = async () => {
//     const response = await axios.get(
//         `${Config.apiUrl}/user/profile`,
//         {
//         headers: {
//             authorization: `Bearer ${user.token}`,
//             "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
//         },
//         }
//     );

//     return response.data;
//     };

//     const getProfileSuccess = (res) => {
//     if (res.isSuccess) {
//         setFormData({
//         companyName: res.user.businessName || "",
//         gstNo: res.user.gstNo || "",
//         businessAddress: res.user.businessAddress || "",
//         panNo: res.user.panNo || "",
//         bankName: res.user.bankName || "",
//         accountNo: res.user.accountNo || "",
//         ifscCode: res.user.ifscCode || "",
//         logo: res.user.logo || null,
//         signature: res.user.signImg || null,
//         });
//     }
//     };

//     const getProfileError = (err) => {
//         toast.error(err?.response?.data?.msg || "Something went wrong");
//     };

//     const {
//         mutate: getProfileMutate,
//         isLoading: getProfileLoading,
//         } = useMutation(getProfileFunction, {
//         onSuccess: getProfileSuccess,
//         onError: getProfileError,
//     });

//     useEffect(() => {
//         getProfileMutate();
//     }, []);

// //------------Update Profile Details----------
//     const updateProfileFunction = async (values) => {
//     return await axios.post(
//         `${Config.apiUrl}/user/editProfile`,
//         values,
//         {
//         headers: {
//             authorization: `Bearer ${user.token}`,
//             "Content-Type": "multipart/form-data",
//         },
//         }
//     );
//     };

//     const updateProfileSuccess = (res) => {
//     if (res.data.isSuccess) {
//         toast.success(res.data.msg);

//         getProfileMutate(); // refresh latest data

//         handleClose();
//     } else {
//         toast.error(res.data.msg);
//     }
//     };

//     const updateProfileError = (err) => {
//     toast.error(err?.response?.data?.msg || "Something went wrong");
//     };

//     const {
//     mutate: updateProfileMutate,
//     isLoading: updateProfileLoading,
//     } = useMutation(updateProfileFunction, {
//     onSuccess: updateProfileSuccess,
//     onError: updateProfileError,
//     });

//   const handleSubmit = (values) => {
//     const formData = new FormData();

//     formData.append("companyName", values.companyName);
//     formData.append("gstNo", values.gstNo || "");
//     formData.append("businessAddress", values.businessAddress || "");
//     formData.append("panNo", values.panNo || "");
//     formData.append("bankName", values.bankName || "");
//     formData.append("accountNo", values.accountNo || "");
//     formData.append("ifscCode", values.ifscCode || "");
    
//     if (values.logo?.length > 0) {
//     formData.append("logo", values.logo[0]);
//     } else {
//     formData.append("logo", "");
//     }

//     if (values.signature?.length > 0) {
//       formData.append("signImg", values.signature[0]);
//     } else {
//       formData.append("signImg", "");
//     }

//     updateProfileMutate(formData);
//   };

//   const StepOneForm = () => (
//   <Formik
//     initialValues={formData}
//     enableReinitialize
//     validationSchema={stepOneSchema}
//     onSubmit={(values) => {
//       setFormData((prev) => ({
//         ...prev,
//         ...values,
//       }));

//       setCurrentStep(2);
//     }}
//   >
//     {({ values, errors, touched, setFieldValue }) => (
//       <Form>
//         <ModalSubHeading>Step 1</ModalSubHeading>
//         <ModalHeading>Business Information</ModalHeading>

//         <ScrollableContent className="max-h-[calc(100dvh-180px)]">
//           <Wrapper>

//             <InputGroup>
//               <Label>Company / Firm Name *</Label>
//               <FieldWrappers>
//                 <Field
//                   name="companyName"
//                   placeholder="Enter company name"
//                   autoComplete="off"
//                 />
//               </FieldWrappers>
//               {errors.companyName && touched.companyName && (
//                 <ErrorMessage>{errors.companyName}</ErrorMessage>
//               )}
//             </InputGroup>

//             <CombineInputGroup>
//               <InputGroup>
//                 <Label>GST Number</Label>
//                 <FieldWrappers>
//                   <Field
//                     name="gstNo"
//                     placeholder="Enter gst number"
//                     autoComplete="off"
//                     onChange={(e) => {
//                       const value = e.target.value.toUpperCase();

//                       if (/^[A-Z0-9]*$/.test(value) && value.length <= 15) {
//                           setFieldValue("gstNo", value);
//                       }
//                       }}
//                   />
//                 </FieldWrappers>
//               </InputGroup>

//               <InputGroup>
//                 <Label>PAN Number</Label>
//                 <FieldWrappers>
//                   <Field
//                     name="panNo"
//                     placeholder="Enter pan number"
//                     value={values.panNo}
//                     autoComplete="off"
//                     onChange={(e) => {
//                       const value = e.target.value.toUpperCase();

//                       if (/^[A-Z0-9]*$/.test(value) && value.length <= 10) {
//                       setFieldValue("panNo", value);
//                       }
//                   }}
//                   />
//                 </FieldWrappers>
//               </InputGroup>
//             </CombineInputGroup>

//             <InputGroup>
//               <Label>Bank Name</Label>
//               <FieldWrappers>
//                 <Field
//                   name="bankName"
//                   placeholder="Enter bank name"
//                   autoComplete="off"
//                 />
//               </FieldWrappers>
//             </InputGroup>

//            <CombineInputGroup>
//                 <InputGroup>
//                     <Label>Account Number</Label>
//                     <FieldWrappers>
//                         <Field
//                             name="accountNo"
//                             placeholder="Enter account number"
//                             value={values.accountNo}
//                             onChange={(e) => {
//                                 const value = e.target.value;

//                                 if (/^\d*$/.test(value) && value.length <= 18) {
//                                 setFieldValue("accountNo", value);
//                                 }
//                             }}
//                             autoComplete="off"
//                         />
//                     </FieldWrappers>
//                     </InputGroup>

//                     <InputGroup>
//                     <Label>IFSC Code</Label>
//                     <FieldWrappers>
//                         <Field
//                             name="ifscCode"
//                             placeholder="Enter ifsc code"
//                             value={values.ifscCode}
//                             onChange={(e) => {
//                                 const value = e.target.value.toUpperCase();

//                                 if (/^[A-Z0-9]*$/.test(value) && value.length <= 11) {
//                                 setFieldValue("ifscCode", value);
//                                 }
//                             }}
//                             autoComplete="off"
//                         />
//                     </FieldWrappers>
//                 </InputGroup>
//            </CombineInputGroup>

//             <InputGroup>
//               <Label>Business Address</Label>
//               <Field
//                 as={Textarea}
//                 name="businessAddress"
//                 rows={4}
//                 placeholder="Enter address"
//                 // onChange={(e) => {
//                 //   const value = e.target.value;

//                 //   if (value.length <= 150) {
//                 //     setFieldValue("businessAddress", value);
//                 //   }
//                 // }}
//               />
//             </InputGroup>

//           </Wrapper>
//         </ScrollableContent>

//         <ActionSection>
//           <SideCancelBtn
//             type="button"
//             onClick={handleClose}
//           >
//             Cancel
//           </SideCancelBtn>

//           <SubmitBtn type="submit">
//             Next
//           </SubmitBtn>
//         </ActionSection>
//       </Form>
//     )}
//   </Formik>
// );

// const StepTwoForm = () => (
//   <Formik
//      initialValues={{
//     bankName: formData.bankName,
//     accountNo: formData.accountNo,
//     ifscCode: formData.ifscCode,
//     logo: formData.logo,
//     signature: formData.signature,
//   }}
//     enableReinitialize
//     validationSchema={stepTwoSchema}
//     onSubmit={(values) => {
//       const finalValues = {
//         ...formData,
//         ...values,
//       };

//       handleSubmit(finalValues);
//     }}
//   >
//     {({ errors, touched, values, setFieldValue }) => (
//       <Form>

//         <ModalSubHeading>Step 2</ModalSubHeading>
//         <ModalHeading>Banking & Branding</ModalHeading>

//         <ScrollableContent className="max-h-[calc(100dvh-180px)]">
//           <Wrapper>

//             <InputGroup>
//               <Label>Upload Logo</Label>

//               <Field name="logo">
//                 {(props) => (
//                   <DropZone
//                     componentFor="logo"
//                     setFieldValue={props.form.setFieldValue}
//                     initialFile={formData.logo}
//                   />
//                 )}
//               </Field>
//             </InputGroup>

//             <InputGroup>
//               <Label>Upload Signature</Label>

//               <Field name="signature">
//                 {(props) => (
//                   <DropZone
//                     componentFor="signature"
//                     setFieldValue={props.form.setFieldValue}
//                     initialFile={formData.signature}
//                   />
//                 )}
//               </Field>
//             </InputGroup>

//           </Wrapper>
//         </ScrollableContent>

//         <ActionSection>

//           <SideCancelBtn
//             type="button"
//             onClick={() => setCurrentStep(1)}
//           >
//             Back
//           </SideCancelBtn>

//           <SubmitBtn
//             type="submit"
//             disabled={updateProfileLoading}
//           >
//             {updateProfileLoading ? "Updating..." : "Update"}
//           </SubmitBtn>

//         </ActionSection>

//       </Form>
//     )}
//   </Formik>
// );


//   return (
//     <Container
//       style={{
//         height: `${height}px`,
//         overflow: "auto",
//         WebkitOverflowScrolling: "touch",
//       }}
//     >
//       <ModalHeader>
//         <Title>{"Company Details"}</Title>
//         <button onClick={handleClose}>
//           <MdClose color="white" size={24} />
//         </button>
//       </ModalHeader>

//         {getProfileLoading ? (
//       <Loading />
//     ) : (
//       <div className="px-6 h-full flex flex-col justify-between">
//             {currentStep === 1 && (
//                 <StepOneForm
//                     formData={formData}
//                     setFormData={setFormData}
//                     setCurrentStep={setCurrentStep}
//                     handleClose={handleClose}
//                 />
//             )}

//             {currentStep === 2 && (
//                 <StepTwoForm
//                     formData={formData}
//                     handleSubmit={handleSubmit}
//                     setCurrentStep={setCurrentStep}
//                     updateProfileLoading={updateProfileLoading}
//                 />
//             )}
//         </div>
//         )}
//     </Container>
//   );
// };

// {/* <div className="px-6 h-full flex flex-col justify-between">
//             {currentStep === 1 && (
//                 <StepOneForm
//                     formData={formData}
//                     setFormData={setFormData}
//                     setCurrentStep={setCurrentStep}
//                     handleClose={handleClose}
//                 />
//             )}

//             {currentStep === 2 && (
//                 <StepTwoForm
//                     formData={formData}
//                     handleSubmit={handleSubmit}
//                     setCurrentStep={setCurrentStep}
//                     updateProfileLoading={updateProfileLoading}
//                 />
//             )}
//         </div> */}

// // Styled components
// const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
// const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
// const Title = tw.h1`text-white text-lg font-medium`;
// const ErrorMessage = tw.div`text-red-500 text-xs mt-1`;
// const Textarea = tw.textarea`min-h-30 border border-gray-300 rounded pl-2 py-2  focus:outline-none duration-200 w-full h-30 resize-y  break-words overflow-hidden`;

// export default ProfileModal;
